/**
 * Hook pour récupérer la configuration publique de l'application.
 * @module hooks/usePublicConfig
 */

import { useState, useEffect } from 'react';
import { getPublicConfig } from '../services/appConfigService';

const defaultPublicConfig = {
  accountCreationEnabled: true,
  paymentsEnabled: true,
  maintenanceMode: false,
  premiumFeatureGating: null,
};

export function usePublicConfig() {
  const [config, setConfig] = useState(defaultPublicConfig);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getPublicConfig()
      .then((data) => {
        if (!cancelled) {
          setConfig(data);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setConfig(defaultPublicConfig);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { config, loading };
}
